import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { Divider } from '@sas/nova-commons/components/Divider';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { Add } from '@sas/react-svg';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ObjectSearchState } from '../../../../store/objectSearch/ObjectSearchState';
import { selectObjectSearchState } from '../../../../store/selectors';
import { PanelHeader } from '../components/PanelHeader';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { useI18n } from '../../../../locale/I18nContext';
import { PanelListItem } from '../components/PanelListItem';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
import cn from './SearchResultPanel.css.json';
import './SearchResultPanel.css';
const useSearchResultPanelId = createUseHtmlId('SearchResultPanel');
export const SearchResultPanelBase = (props) => {
    const dt = useDesignTokens();
    const localize = useI18n();
    const spacingTokens = renderInlineCssVars({ 'spacing-m': dt.spacing.core.m }, 'searchResult');
    const headingId = useSearchResultPanelId();
    return (React.createElement(Flow, { role: "region", "aria-labelledby": headingId, spacing: "m", orientation: "vertical", className: cn.container, style: spacingTokens },
        React.createElement(PanelHeader, { id: props.id, headingId: headingId, text: localize({ key: 'SearchResultPanel.title.txt' }), menuSections: [
                { items: [{ text: localize({ key: 'SearchResultPanel.menu.delete.txt' }) }] },
            ], onMenuItemSelected: () => props.actions.notifyDeleteSearchResults(props.id, [props.searchIndex]), type: 'result' }),
        React.createElement("div", { className: cn.body },
            React.createElement(PanelListItem, { item: props.searchResult, counter: props.searchIndex + 1, infoOnly: true })),
        React.createElement(Divider, { variant: "standard" }),
        React.createElement("div", { className: cn.footer },
            React.createElement(Button, { variant: ButtonVariant.Light, text: localize({ key: 'SearchResultPanel.convert.txt' }), icon: { icon: Add }, onPress: () => {
                    props.actions.notifyConvertSearchResults(props.id, [props.searchIndex]);
                } }))));
};
export const SearchResultPanel = connect((state, props) => {
    var _a;
    const { searchResults } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const searchResult = searchResults === null || searchResults === void 0 ? void 0 : searchResults[props.searchIndex];
    if (!searchResult) {
        throw new Error(`Search result not found`);
    }
    return { searchResult };
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(SearchResultPanelBase);
